<template>
  <div class="miya-customerPolicy">
    <el-scrollbar style="height:100%;">
      <div class="pageBox">
        <h1 class="title1 fontSH">{{$t('menu.m5_2')}}</h1>
        <p class="title2">{{$t('tos.t_1')}}</p>
        <p class="text2">{{$t('tos.c_11')}}</p>
        <p class="text2">{{$t('tos.c_12')}}</p>
        <p class="text2">{{$t('tos.c_13')}}</p>
        <p class="title2">{{$t('tos.t_2')}}</p>
        <p class="text2">{{$t('tos.c_21')}}</p>
        <p class="title2">{{$t('tos.t_3')}}</p>
        <p class="text2">{{$t('tos.c_31')}}</p>
        <p class="text2">{{$t('tos.c_32')}}</p>
        <p class="text2">{{$t('tos.c_33')}}</p>
        <p class="text2">{{$t('tos.c_34')}}</p>
        <p class="text2">{{$t('tos.c_35')}}</p>
        <p class="text2">{{$t('tos.c_36')}}</p>
        <p class="text2">{{$t('tos.c_37')}}</p>
        <p class="text2">{{$t('tos.c_38')}}</p>
        <p class="text2">{{$t('tos.c_39')}}</p>
        <p class="text2">{{$t('tos.c_310')}}</p>
        <p class="text2">{{$t('tos.c_311')}}</p>
        <p class="title2">{{$t('tos.t_4')}}</p>
        <p class="text2">{{$t('tos.c_41')}}</p>
        <p class="text2">{{$t('tos.c_42')}}</p>
        <p class="text2">{{$t('tos.c_43')}}</p>
        <p class="text2">{{$t('tos.c_44')}}</p>
        <p class="text2">{{$t('tos.c_45')}}</p>
        <p class="text2">{{$t('tos.c_46')}}</p>
        <p class="text2">{{$t('tos.c_47')}}</p>
        <p class="text2">{{$t('tos.c_48')}}</p>
        <p class="text2">{{$t('tos.c_49')}}</p>
        <p class="text2">{{$t('tos.c_410')}}</p>
        <p class="text2">{{$t('tos.c_411')}}</p>
        <p class="text2">{{$t('tos.c_412')}}</p>
        <p class="text2">{{$t('tos.c_413')}}</p>
        <p class="title2">{{$t('tos.t_5')}}</p>
        <p class="text2">{{$t('tos.c_51')}}</p>
        <p class="title2">{{$t('tos.t_6')}}</p>
        <p class="text2">{{$t('tos.c_61')}}</p>
        <p class="title2">{{$t('tos.t_7')}}</p>
        <p class="text2">{{$t('tos.c_71')}}</p>
        <p class="title2">{{$t('tos.t_8')}}</p>
        <p class="text2">{{$t('tos.c_81')}}</p>
        <p class="title2">{{$t('tos.t_9')}}</p>
        <p class="text2">{{$t('tos.c_91')}}</p>
        <p class="title2">{{$t('tos.t_10')}}</p>
        <p class="text2">{{$t('tos.c_101')}}</p>
        <p class="title2">{{$t('tos.t_11')}}</p>
        <p class="text2">{{$t('tos.c_11_1')}}</p>
        <p class="title2">{{$t('tos.t_12')}}</p>
        <p class="text2">{{$t('tos.c_121')}}</p><br/><br/>
      </div>
    </el-scrollbar>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  mounted () {  
  },
  methods: {
  },
  components: {}
}
</script>
<style scoped lang="stylus">
.miya-customerPolicy
  height 100%
  .pageBox
    padding 40px 40px 20px 40px
  .title1
    color $c1
    font-size 28px
    margin 10px 0 32px 0
  .title2
    font-size $f18
    color $c1
    fontWeight()
    margin 24px 0 12px 0
  .text2
    font-size $f14
    color $c2
    line-height 24px
</style>